
export class Login{
    System:string;
    Username:string;
    Password:string;

    Email: string;
    PasswordResetCode: string;
    ReEnterPassword: string;    
}
